import { Directive, HostListener, inject, Input, Renderer2 } from '@angular/core';
import { UpdatePhotoService } from '../../services/update-photo.service';
import { MatDialog } from '@angular/material/dialog';
import { StatusModalComponent } from '@app/components/shared/status-modal/status-modal.component';
import { UserStateService } from '@app/services/user-state/user-state.service';
import { LocalStorageKeys } from '@app/utils/enums/local-storage';

@Directive({
  selector: '[appChangePhoto]',
  standalone: true,
})
export class ChangePhotoDirective {
  @Input('appChangePhoto') targetImg!: HTMLImageElement;

  private readonly renderer = inject(Renderer2);
  private readonly updatePhotoService = inject(UpdatePhotoService);
  private readonly userStateService = inject(UserStateService);
  private readonly dialog = inject(MatDialog);
  private readonly MAX_SIZE = 1000000;

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) return;

    if (file.size > this.MAX_SIZE) {
      this.openErrorModal();
      input.value = '';

      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;

      this.renderer.setAttribute(this.targetImg, 'src', base64);

      this.userStateService.setPhotoUrl(base64);

      const id = localStorage.getItem(LocalStorageKeys.STAFF_ID);
      if (id) {
        const formData = new FormData();
        formData.append('image', file);

        this.updatePhotoService.savePhoto(id, formData).subscribe();
      }
    };

    reader.readAsDataURL(file);
    input.value = '';
  }

  private openErrorModal(): void {
    this.dialog.open(StatusModalComponent, {
      data: {
        isSuccess: false,
        title: 'user-profile.general.errors.photoTitle',
        description: 'user-profile.general.errors.photoText',
      },
    });
  }
}
